'use strict'

translations =
  details: Groupon.LS.translations.common?.details
  hide: Groupon.LS.translations.common?.hide
  close: Groupon.LS.translations.ax?.close

presentBanner = (el, msg, template) ->
  id = msg.id.toString()
  blockedIds = getBlockedMessageIds()
  unless id in blockedIds
    msg.t = translations
    el.innerHTML = template.render msg
    if (appFilter = document.querySelector('.t-main-inner .t-header-sublink, .t-main-inner > div[data-bhw="BrowseHeader"]'))
      appFilter.insertAdjacentElement('afterend', el)
    el.querySelector('.hide-link').setAttribute('aria-label', translations.close)
    attachDismissListener(el, id)

getBlockedMessageIds = ->
  value = Cookie.get('msg_hide')
  if value then value.split ',' else []

setBlockedMessageIds = (blocked) ->
  # keep last 20 blocked campaigns, if we hit 20, remove the
  # least recently blocked campaign (first in the list)
  if (blocked.length > 20)
    blocked.shift()
  value = blocked.join(',')
  Cookie.set('msg_hide', value, { consentClass: 'essential' })

blockMessage = (message_id) ->
  blocked = getBlockedMessageIds()
  unless message_id in blocked
    blocked.push(message_id)
    setBlockedMessageIds(blocked)

attachDismissListener = (el, id) ->
  hideLinkEl = el.querySelector('.hide-link')
  hideLinkEl.setAttribute('aria-label', translations.close or 'close')
  hideLinkEl.addEventListener('click', (event) ->
    event.preventDefault()
    el.classList.add('t-hide', 'hide')
    if id > 0
      blockMessage(id)
  , { once: true })

module.exports = presentBanner
